import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface HeroState {
  /** Tryb kompaktowy: nagłówek bez kafelków, wniosku i szybkich akcji (preferencja urządzenia). */
  compact: boolean;
  toggle: () => void;
}

export const useHeroStore = create<HeroState>()(
  persist(
    (set) => ({ compact: false, toggle: () => set((s) => ({ compact: !s.compact })) }),
    { name: 'nexops-hero-v1', storage: createJSONStorage(() => localStorage), partialize: (s) => ({ compact: s.compact }) },
  ),
);
